import { createContext, useState } from 'react';

const ALERT_TIME = 5000;
const initialState = {
  text: '',
  type: '',
};

const AlertContext = createContext({
  ...initialState,
  setAlert: () => {},
});

export const AlertProvider = ({ children }) => {
  const [text, setText] = useState('');
  const [type, setType] = useState('');

  const setAlert = (text, type) => {
    setText(text);
    setType(type);

    if(type === "success"){
        setTimeout(() => {
          setText('');
          setType('');
        }, ALERT_TIME);
    };

    if(type === "error"){
      setTimeout(() => {
        setText('');
        setType('');
      }, ALERT_TIME);
  };

  };

  const hideAlert = () => {
    setText('');
    setType('');
  };

  return (
    <AlertContext.Provider
      value={{
        text,
        type,
        setAlert,
        hideAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContext;
